import {
  I2cAlert,
} from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useEffect, useState } from "react";
import "../../PrepaidComponents/Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { validationSchema, fields } from "./ValidationSchema";
import AccountsAndCardServices from "./AccountsAndCardServices";
import RewardsPromotionsAndDisputeForms from "./RewardsPromotionsAndDisputeForms";
import ManagePinCreditPaymentsAndSpendingControl from "./ManagePinCreditPaymentsAndSpendingControl";
import BankaccountsBillpaymentsWallet from "./BankaccountsBillpaymentsWallet";
import ManageProfile from "./ManageProfile";
import AdditionalCardsAccessCode from "./AdditionalCardsAccessCode";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
import { creditPaymentFeature } from "./stringUtils"

const CardManagementFeature = ({
  type,
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const appSelectionForProgram = addFormData[1]?.["1_0"]?.app_selection_for_program || [];
  const [isFormDataUpdated, setIsFormDataUpdated] = useState(false);
  const [fileJson, setFileJson] = useState();
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    // reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    // criteriaMode: "all",
    criteriaMode: "firstError",
    defaultValues: {
      card_management_feature_my_account_feature_app_enable: "Yes",
      card_management_feature_my_account_feature_required_for: [],
      card_management_feature_my_account_feature_required_for_custom: "",
      card_management_feature_card_services_feature_app_enable: "Yes",
      card_management_feature_card_services_feature_required_for: [],
      card_management_feature_card_services_feature_app_enable_custom: "",
      card_management_feature_card_services_card_activation_after_login: "Yes",
      card_management_feature_card_services_info_for_validation: [],
      card_management_feature_rewards_and_cashback_feature_app_enable: "Yes",
      card_management_feature_rewards_and_cashback_feature_required_for: [],
      card_management_feature_rewards_and_cashback_rewards_type: "",
      card_management_feature_rewards_and_cashback_manual_redeem: "Yes",
      card_management_feature_rewards_and_cashback_feature_app_enable_custom: "",
      card_management_feature_credit_promotions_feature_app_enable: "Yes",
      card_management_feature_credit_promotions_feature_required_for: [],
      card_management_feature_credit_promotions_feature_app_enable_custom: "",
      card_management_feature_dispute_form_feature_app_enable: "Yes",
      card_management_feature_dispute_form_feature_required_for: [],
      card_management_feature_dispute_form_dispute_options: [],
      card_management_feature_dispute_form_feature_app_enable_custom: "",
      card_management_feature_dispute_form_custom_form_file: "",
      card_management_feature_dispute_center_feature_app_enable: "Yes",
      card_management_feature_dispute_center_feature_required_for: [],
      card_management_feature_dispute_center_feature_app_enable_custom: "",
      card_management_feature_account_notification_feature_app_enable: "Yes",
      card_management_feature_account_notification_feature_required_for: [],
      card_management_feature_manage_pin_feature_app_enable: "Yes",
      card_management_feature_manage_pin_feature_required_for: [],
      card_management_feature_manage_pin_info_verification_for_change_pin: [],
      card_management_feature_manage_pin_enable_captcha: "Yes",
      card_management_feature_manage_pin_feature_app_enable_custom: "",
      card_management_feature_credit_payments_feature_app_enable: "Yes",
      card_management_feature_credit_payments_feature_required_for: [],
      card_management_feature_credit_payments_feature_app_enable_custom: "",
      card_management_feature_credit_payments_features_data: [],
      card_management_feature_spending_controls_feature_required_for: [],
      card_management_feature_bank_accounts_feature_app_enable: "Yes",
      card_management_feature_bank_accounts_feature_required_for: [],
      card_management_feature_bank_accounts_feature_app_enable_custom: "",
      card_management_feature_bank_accounts_primary_methods_for_account_setup: "",
      card_management_feature_bank_accounts_fallback_micropayment_method: "Yes",
      card_management_feature_bill_payments_feature_app_enable: "Yes",
      card_management_feature_bill_payments_feature_required_for: [],
      card_management_feature_bill_payments_feature_app_enable_custom: "",
      card_management_feature_wallet_provision_feature_app_enable: "Yes",
      card_management_feature_wallet_provision_digital_wallet_types: [],
      card_management_feature_wallet_provision_payment_networks: [],
      card_management_feature_manage_profile_feature_required_for: [],
      card_management_feature_manage_profile_info_verification_for_pin_change: [],
      card_management_feature_manage_profile_enable_captcha: "Yes",
      card_management_feature_manage_additional_cards_feature_app_enable: "Yes",
      card_management_feature_manage_additional_cards_feature_required_for: [],
      card_management_feature_manage_additional_cards_feature_app_enable_custom: "",
      card_management_feature_manage_access_code_feature_app_enable: "Yes",
      card_management_feature_manage_access_code_feature_required_for: [],
      card_management_feature_manage_access_code_feature_app_enable_custom: "",
      card_management_feature_manage_access_code_features: [],
      card_management_feature_manage_access_code_info_verification_for_code_access: [],
      card_management_feature_message_center_feature_app_enable: "Yes",
      card_management_feature_message_center_feature_required_for: [],
      card_management_feature_message_center_feature_app_enable_custom: "",
      card_management_feature_additional_service: "",
    },
  });
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      if (type === "credit") {
        fields.forEach((field) => {
          methods.setValue(field, formDataJson[5]["5_0"][field] ?? "");
        });
        setFileJson(formDataJson[5]["5_0"]);
      }
      else {
        fields.forEach((field) => {
          methods.setValue(field, formDataJson[6]["6_0"][field] ?? "");
          setFileJson(formDataJson[6]["6_0"])
        });
      }
      methods.trigger();
      // handleValueChanges();
      setIsFormDataUpdated(true)
    }
  }, [isFetching]);

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);
  const handleValueChanges = () => {
    const updatedValues = methods.getValues();

    if (type === "credit") {
      setAddFormData((prevData) => ({

        ...prevData,
        5: {
          ...prevData["5"],
          "5_0": {
            ...prevData["5"]["5_0"],
            ...updatedValues, // Merging updated values
          },
        },
      }));
    } else {
      setAddFormData((prevData) => ({
        ...prevData,
        6: {
          ...prevData["6"],
          "6_0": {
            ...prevData["6"]["6_0"],
            ...updatedValues, // Merging updated values
          },
        },
      }));
    }
  };
 
  console.log("card management", errors)
  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (type === "credit") {
      if (errorsLength === 0) setFormValidStates("5_0", true);
      else setFormValidStates("5_0", false);
    } else {
      if (errorsLength === 0) setFormValidStates("6_0", true);
      else setFormValidStates("6_0", false);
    }
    handleValueChanges();
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading">
              <span className="productIconFlex">
                <span slot="label" className="organize-tooltip">
                  Home/Dashboard
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div>
          </div>
          <div i2c-grid="12">
            <I2cAlert
              open
              type="plain"
              variant="primary"
              headerArt="cs-linear-info"
              layout="layoutAsideLeft"
            >
              <span slot="label">This will be the default landing screen and is enabled by default.</span>
              This feature is common to both C-Holder Web and Mobile.
            </I2cAlert>
          </div>
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading">
              <span className="productIconFlex">
                <span slot="label" className="organize-tooltip">
                  Biometric Authentication
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div>
          </div>
          <div i2c-grid="12">
            <I2cAlert
              open
              type="plain"
              variant="primary"
              headerArt="cs-linear-info"
              layout="layoutAsideLeft"
            >
              <span slot="label">This feature is available by default.</span>
              This feature is for C-Holder mobile only.
            </I2cAlert>
          </div>
        </div>
        <AccountsAndCardServices
          type={type}
          control={control}
          handleValueChanges={handleValueChanges}
          methods={methods}
          errors={errors}
          appSelectionForProgram={appSelectionForProgram}
          isFormDataUpdated={isFormDataUpdated}
        />
        <RewardsPromotionsAndDisputeForms
          type={type}
          control={control}
          handleValueChanges={handleValueChanges}
          methods={methods}
          errors={errors}
          appSelectionForProgram={appSelectionForProgram}
          fileJson={fileJson}
          setFormValidStates={setFormValidStates}
          setIsFormDataUpdated={setIsFormDataUpdated}
        />
        <ManagePinCreditPaymentsAndSpendingControl
          type={type}
          control={control}
          handleValueChanges={handleValueChanges}
          methods={methods}
          errors={errors}
          appSelectionForProgram={appSelectionForProgram}
          isFormDataUpdated={isFormDataUpdated}
          setIsFormDataUpdated={setIsFormDataUpdated}
        />
        <BankaccountsBillpaymentsWallet
          type={type}
          control={control}
          handleValueChanges={handleValueChanges}
          methods={methods}
          errors={errors}
          appSelectionForProgram={appSelectionForProgram}
        />
        <ManageProfile
          type={type}
          control={control}
          handleValueChanges={handleValueChanges}
          methods={methods}
          errors={errors}
          appSelectionForProgram={appSelectionForProgram}
        />
        <AdditionalCardsAccessCode
          type={type}
          control={control}
          handleValueChanges={handleValueChanges}
          methods={methods}
          errors={errors}
          appSelectionForProgram={appSelectionForProgram}
        />
      </div>
    </React.Fragment>
  );
};

export default CardManagementFeature;
